import { ReportsType } from "./reportsType";

export const reportsReducer = {
  resetReportsError: (state: ReportsType) => {
    state.error = null;
  },
  resetReportsSuccess: (state: ReportsType) => {
    state.success = null;
  },
  resetReportsFetching: (state: ReportsType) => {
    state.fetching = false;
  },
  resetLedgerStatement: (state: ReportsType) => {
    state.ledgerStatement = [];
    state.closingBalance= 0;
    state.openingBalance= 0;
    state.totalDebitCreditAmount={
      column_name:"",
      total_credit_amount: 0,
      total_debit_amount: 0
    }
  },
  resetTrialBalance: (state: ReportsType) => {
    state.trialBalance = [];
  },
  resetStockReportsSummary: (state: ReportsType) => {
    state.stockReportsSummaryData = [];
  },
  resetStockStatement: (state: ReportsType) => {
    state.stockStatementData = [];
  },
  resetExpenseProfitLoss: (state: ReportsType) => {
    state.expenseProfitLoss = [];
  },
  resetRevenueProfitLoss: (state: ReportsType) => {
    state.revenueProfitLoss = [];
  },
  resetCustomerBalanceSheetData: (state: ReportsType) => {
    state.customerBalanceSheetData = [];
  },
  resetSupplierBalanceSheetData: (state: ReportsType) => {
    state.supplierBalanceSheetData = [];
  },
  resetPaymentBalanceSheetData: (state: ReportsType) => {
    state.paymentBalanceSheetData = [];
  },
  resetEquityBalanceSheetData: (state: ReportsType) => {
    state.equityBalanceSheetData = [];
  },
  resetAssetsBalanceSheetData: (state: ReportsType) => {
    state.assetsBalanceSheetData = [];
  },
  resetLiabilitiesBalanceSheetData: (state: ReportsType) => {
    state.liabilitiesBalanceSheetData = [];
  },
  resetTaxPayableBalanceSheetData: (state: ReportsType) => {
    state.taxPayableBalanceSheetData = [];
  },
  resetTaxReceivableBalanceSheetData: (state: ReportsType) => {
    state.taxReceivableBalanceSheetData = [];
  },
  resetStockSummaryBalanceSheetData: (state: ReportsType) => {
    state.stockSummaryBalanceSheetData = [];
  },
  resetTaxLedgerStatementCount: (state: ReportsType) => {
    state.ledgerStatementCount = 0;
  },
  resetDetailedProfitLossStatement: (state: ReportsType) => {
    state.detailedProfitLossData = {
      expenses: [],
      income: [],
      net_profit: 0,
      total_expense: 0,
      total_revenue: 0,
    };
  },
  resetDetailedBalanceSheet: (state: ReportsType) => {
    state.detailedBalanceSheetData = {};
  },
  resetDetailedTrialBalance: (state: ReportsType) => {
    state.detailedTrialBalance = {};
  },
  resetBalanceSheetTotal: (state: ReportsType) => {
    state.balanceSheetTotal = {
      customer_total_value: 0,
      supplier_total_value: 0,
      payment_total_value: 0,
      assets_total_value: 0,
      equity_total_value: 0,
      liabilities_total_value: 0,
      tax_payable_value: 0,
      tax_receivable_value: 0,
      net_profit: 0,
      total_stock_summary_value: 0,
    };
  },
  resetDayBookListData: (state: ReportsType) => {
    state.dayBookListData = [];
  },
  resetGeneralLedgerListData: (state: ReportsType) => {
    state.generalLedgerListData = [];
  },
  resetCostOfGoodsData: (state: ReportsType) => {
    state.costOfGoods = {
      opening_stock: 0,
      closing_stock: 0,
      gross_profit: 0,
      total_cogs: 0,
      total_income: 0,
      total_direct_income: 0,
      total_indirect_income: 0,
      total_expense: 0,
      total_direct_expense: 0,
      total_indirect_expense: 0,
      net_profit: 0,
      direct_expenses: [],
      indirect_expenses: [],
      indirect_income: [],
      direct_income: [],
    };
  },
  resetAgeingAnalysisList: (state: ReportsType) => {
    state.ageingAnalysisList = [];
  },
  resetAgeingAnalysisTotalCount: (state: ReportsType) => {
    state.ageingAnalysisTotalCount = 0;
  },
  resetReceiptAndPayment: (state: ReportsType) => {
    state.receiptAndPayment = {
      receipt: {
        opening_balance: [],
        total_opening_balance: 0,
        others_data: [],
        revenues_data: [],
        tds_gst_receivable_data: [],
        receipt_total:0
      },
      payment: {
        closing_balance: [],
        total_closing_balance: 0,
        others_data: [],
        expenses_data: [],
        tds_gst_payble_data: [],
        payment_total:0
      }
    }
  },
  resetStocklimitData: (state: ReportsType) => {
    state.stocklimitData = [];
  },
  resetStockLimitTotalCount:(state: ReportsType)=>{
    state.stockLimitTotalCount=0;
  },
  resetBatchSummaryReportData: (state: ReportsType) => {
    state.batchSummaryReportData = [];
  },
  resetBatchVoucherReportData: (state: ReportsType) => {
    state.batchVoucherData = [];
  },
  resetMonthlyLedgerSummaryData: (state: ReportsType) => {
    state.monthlyLedgerSummaryData = [];
  },
  resetMonthlyLedgerSummaryTotal: (state: ReportsType) => {
    state.monthlyLedgerSummaryTotal = {
      total_debits: 0,
      total_credits: 0,
      closing_balance: 0,
      opening_balance: 0,
    }
  }
};
